import React from 'react';
import { useTranslation } from 'react-i18next';
import './BillSummary.css';

function BillSummary({ orders, diners, totalSession, totalPaid, totalUnpaid, settings, tableNumber, children }) {
  const { t } = useTranslation();

  return (
    <div className="bill-summary">
      <div className="bill-header">
        <span className="material-icons" aria-hidden="true">receipt_long</span>
        <div>
          <h3>{t('bill.title')}</h3>
          {tableNumber && <span className="bill-table">{t('orders.table')} {tableNumber}</span>}
        </div>
      </div>

      {/* Pedidos agrupados por comensal */}
      {diners && diners.length > 0 && (
        <div className="bill-diners">
          {diners.map((diner, idx) => (
            <div key={diner.customerId || idx} className="bill-diner">
              <div className="bill-diner-header">
                <span className="bill-diner-name">
                  {t('bill.ordersBy')} {diner.customerName}
                </span>
                <span className="bill-diner-subtotal">${diner.subtotal.toFixed(2)}</span>
              </div>
              <div className="bill-diner-orders">
                {diner.orders.map(order => (
                  <div key={order.orderId} className="bill-order">
                    <div className="bill-order-header">
                      <span className="bill-order-id">#{order.orderId.slice(-6)}</span>
                      <span className={`bill-payment-badge ${order.paymentStatus === 'paid' ? 'paid' : 'unpaid'}`}>
                        {order.paymentStatus === 'paid' ? t('bill.paid') : t('bill.unpaid')}
                      </span>
                    </div>
                    {order.items.map((item, i) => (
                      <div key={i} className="bill-item">
                        <span>{item.quantity}x {item.name}</span>
                        <span>${(item.price * item.quantity).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Totales */}
      <div className="bill-totals">
        <div className="bill-total-line">
          <span>{t('common.total')}</span>
          <span className="bill-amount">${(totalSession || 0).toFixed(2)}</span>
        </div>
        {totalPaid > 0 && (
          <div className="bill-total-line bill-paid-line">
            <span>{t('bill.totalPaid')}</span>
            <span className="bill-amount bill-paid">-${totalPaid.toFixed(2)}</span>
          </div>
        )}
        <div className="bill-total-line bill-remaining-line">
          <strong>{totalUnpaid > 0 ? t('bill.remaining') : t('bill.allPaid')}</strong>
          <strong className={`bill-amount ${totalUnpaid > 0 ? 'bill-unpaid' : 'bill-all-paid'}`}>
            ${(totalUnpaid || 0).toFixed(2)}
          </strong>
        </div>
      </div>

      {/* Slot for payment options (Fase 3) */}
      {children}
    </div>
  );
}

export default BillSummary;
